import { useSelector } from "react-redux";
import { isDateValid, isToday } from "../helpers/dates";
import { getLocalStorage } from "../sessionAndLocalStorage";
import { getAppraisalData, getMileageIsReadyToRender, selectAppraisal } from "../store/selectors";
import { localQuestionsMatchCurrentSetOptions } from "../helpers/appraisals";

export default function useReuseAppraisals() {
  const { isReuseAppraisal } = useSelector(selectAppraisal);
  const localAppraisalsData = getLocalStorage("appraisalsData") || {};
  const {
    vehicle = {},
    appraisal = {},
    mileageExpiredDate,
    expiredDate = "",
    vehicle: localVehicle = {}
  } = localAppraisalsData;

  const { questions } = useSelector(getAppraisalData);  
  const isMileageValid = isReuseAppraisal && isToday(mileageExpiredDate);
  
  let { mileage: localStorageMileage = "" } = localVehicle;
  
  const { registration } = vehicle;
  
  const { data = {} } = appraisal;
  
  let { questionsAndAnswers: localQuestionsAndAnswers = {} } = data;

  const readyToRender = useSelector(getMileageIsReadyToRender) || !registration

  const islocalAppraisalDataValid = isDateValid({
    expiredDate: expiredDate,
    now: new Date()
  });

  const isQuestionSetValid = localQuestionsMatchCurrentSetOptions(
    questions,
    localQuestionsAndAnswers
  );

  const isLocalAppraisalToBeUsed =
    isReuseAppraisal && islocalAppraisalDataValid;

  return {
    registration,
    islocalAppraisalDataValid,
    localStorageMileage,
    isMileageValid,
    localQuestionsAndAnswers,
    isLocalAppraisalToBeUsed,
    localAppraisalsData,
    isQuestionSetValid,
    readyToRender
  };
}
